export default __webpack_public_path__ + "assets/models/0e6f841f4529715dc1785a54a841446c.glb";